"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.folderFragment = void 0;
exports.folderFragment = `
fragment folderPreview on Folder {
  id
  name
  tree {
    childCount
  }
}
`;
//# sourceMappingURL=folder.js.map